module.exports = __webpack_public_path__ + "img/call-agent.4e5dac4c.svg";